"use client";

import dynamic from "next/dynamic";
import React from "react";

import { pageConfig } from "@/config/pages.config";
import Link from "next/link";
import { useLocale } from "next-intl";

import { routing } from "@/i18n/routing";
import { cn } from "@/utils/cn";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  isWhite?: boolean;
}

// Dynamic import with no SSR to prevent hydration mismatch
const LogoIcon = dynamic<React.SVGProps<SVGSVGElement>>(() => import("@/icons/brand/logo.svg"), {
  ssr: false,
  loading: () => (
    <div className="w-[9.7rem] h-[3rem] bg-gray-200 animate-pulse rounded" />
  ),
});

const LogoWhiteIcon = dynamic(() => import("@/icons/brand/white-logo.svg"), {
  ssr: false,
  loading: () => (
    <div className="w-[9.7rem] h-[3rem] bg-gray-200 animate-pulse rounded" />
  ),
});

export default function Logo({ className, isWhite }: Props) {
  const locale = useLocale();
  const isDefault = locale === routing.defaultLocale;
  const href = isDefault ? "/" : `/${locale}/`;
  return (
    <div className={cn(className)}>
      <Link href={href} className="block">
        {isWhite ? (
          <LogoWhiteIcon className="w-[9.7rem] h-[3rem]" />
        ) : (
          <LogoIcon className="w-[9.7rem] h-[3rem]" />
        )}
      </Link>
    </div>
  );
}
